// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"98453165","700":"20cbf3e5"}[chunkId] + ".chunk.css";
};